export default "__VITE_ASSET__BmCUxx86__"